import { EnvService } from '../env.service';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../env.service";
export class StudioService {
    constructor(http, envService) {
        this.http = http;
        this.httpOptions = {};
        this.apiURL = '';
        this.apiURL = envService.API_URL;
    }
    getStudio(id, options) {
        if (options) {
            let scopes = '';
            const opts = Object.assign({}, options);
            if (opts.scope && opts.scope.length) {
                scopes = '?';
                const optScopes = opts.scope;
                optScopes.forEach((queryParameter) => {
                    scopes += queryParameter + '=1&';
                });
            }
            const apiUrl = this.apiURL + 'spaces/' + id.toString() + scopes;
            return this.http.get(apiUrl);
        }
    }
    getStudioByUsername(username, classId, options) {
        if (options) {
            let scopes = '';
            const opts = Object.assign({}, options);
            if (opts.scope && opts.scope.length) {
                scopes = '?';
                const optScopes = opts.scope;
                optScopes.forEach((queryParameter) => {
                    scopes += queryParameter + '=1&';
                });
            }
            let apiUrl = this.apiURL + 'spaces/username/' + username.toString();
            if (classId) {
                apiUrl += '?classId=' + classId;
            }
            apiUrl += scopes;
            return this.http.get(apiUrl);
        }
    }
}
StudioService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StudioService_Factory() { return new StudioService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.EnvService)); }, token: StudioService, providedIn: "root" });
